import { Button } from 'antd'
import { ExportOutlined } from '@ant-design/icons'
import { EasyModal } from 'src/components'
import { FormConfigSqlPage } from './001'

export default {
  btnFormConfigSql (ListTableContext: any, props: any) {
    const { LABEL } = props.config
    return (
      <EasyModal
        fullModal
        modal={{ title: LABEL }}
        slot={<Button type='primary' icon={<ExportOutlined />}>导出配置</Button>}
      >
        <FormConfigSqlPage />
      </EasyModal>
    )
  }
}